import React, { useState, useEffect } from "react";
import "./ZoomInSlider.css";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";

const ZoomInSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [homeBanners, setHomeBanners] = useState([]);
  const sitedata = useSelector((store) => store.global.loginData);

  useEffect(() => {
    brandingData();
  }, []);

  useEffect(() => {
    if (homeBanners.length === 0) return;
    const interval = setInterval(() => {
      goToNextSlide();
    }, 6000);
    return () => clearInterval(interval);
  }, [currentSlide, homeBanners]);

  const brandingData = async () => {
    const siteTheme = sitedata?.options?.theme;
    const response = await SendPostRequest("branding/banners", {
      theme: siteTheme,
    });
    setHomeBanners(response?.data || []);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? homeBanners.length - 1 : prev - 1
    );
  };

  const goToNextSlide = () => {
    setCurrentSlide((prev) =>
      prev === homeBanners.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <div className="new-zoomin-banner-slider-wrap">
      <div className="new-zoomin-banner-slider">
        <div className="new-zoomin-slides">
          {homeBanners?.map((slide, index) => (
            <div
              key={index}
              className={`new-zoomin-slide ${index === currentSlide ? "active" : ""}`}
            >
              <div className="new-zoomin-image-container">
                {slide?.banner_category === "custom-text" && (
                <div className="new-zoomin-image-overlay-shadow"></div>
                )}
                <img
                  src={slide?.banner_image}
                  alt={slide?.banner_title || `Slide ${index}`}
                  className="new-zoomin-rev-slidebg"
                />
                {/* <div className="new-zoomin-image-overlay"></div> */}
              </div>
              {slide?.banner_category === "custom-text" && (
                <div className="new-zoomin-slide-content-wrapper">
                  <div className="container">
                    <div
                      className={`new-zoomin-slide-content ${slide?.banner_alignment === "right" ? "align-left" : "align-center"
                        }`}
                    >
                      <div className="new-zoomin-rs-layer title-layer banner-title-font">
                        {slide?.banner_title}
                      </div>
                      <p className="new-zoomin-rs-layer description-layer">
                        {slide?.banner_description}
                      </p>
                    </div>
                  </div>
                </div>
              )}

            </div>
          ))}
        </div>

        {/* Navigation arrows */}
        <button className="new-zoomin-nav-arrow new-zoomin-nav-arrow-prev" onClick={goToPrevSlide}>
          &#10094;
        </button>
        <button className="new-zoomin-nav-arrow new-zoomin-nav-arrow-next" onClick={goToNextSlide}>
          &#10095;
        </button>

        {/* Navigation dots */}
        {/* <div className="new-zoomin-slider-nav">
          {homeBanners?.map((_, index) => (
            <button
              key={index}
              className={`new-zoomin-nav-dot ${index === currentSlide ? "active" : ""}`}
              onClick={() => goToSlide(index)}
            ></button>
          ))}
        </div> */}
      </div>
    </div>
  );
};

export default ZoomInSlider;
